var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuffuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 473,
    viewBox: "0 0 371 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.729 397.407V445.87C174.522 453.71 161.773 460.124 144.774 465.113C127.775 470.102 110.776 472.24 92.361 472.24C66.1546 472.24 44.9062 467.251 28.6157 457.273C9.49214 445.87 0.284485 428.765 0.284485 407.385V108.053C0.284485 101.639 4.53417 94.5121 13.7418 88.0979C22.9495 81.6836 35.6985 75.2694 51.2807 69.5678C85.9865 57.452 124.942 51.7505 169.564 51.7505C230.476 51.7505 279.347 67.4297 316.178 98.0756C353.008 128.721 370.716 170.058 370.716 222.084C370.716 274.111 354.425 314.022 321.844 343.242C290.68 369.612 246.766 383.153 190.812 383.153C178.063 383.153 164.606 381.728 149.732 378.877C134.858 376.026 125.65 373.175 120.692 371.037C119.276 372.463 117.859 375.313 117.859 378.164C117.859 388.142 139.816 395.269 183.729 397.407Z",
    fill: "#73FF8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.109 160.793C156.532 160.793 184.437 125.693 184.437 82.3963C184.437 39.0992 156.532 4 122.109 4C87.6853 4 59.7798 39.0992 59.7798 82.3963C59.7798 125.693 87.6853 160.793 122.109 160.793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.61272,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.184 160.793C265.607 160.793 293.513 125.693 293.513 82.3963C293.513 39.0992 265.607 4 231.184 4C196.761 4 168.855 39.0992 168.855 82.3963C168.855 125.693 196.761 160.793 231.184 160.793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.61272,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.978 145.113C224.927 145.113 241.1 117.034 241.1 82.3965C241.1 47.7588 224.927 19.6794 204.978 19.6794C185.028 19.6794 168.855 47.7588 168.855 82.3965C168.855 117.034 185.028 145.113 204.978 145.113Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5686 145.113C119.518 145.113 135.691 117.034 135.691 82.3965C135.691 47.7588 119.518 19.6794 99.5686 19.6794C79.6187 19.6794 63.4462 47.7588 63.4462 82.3965C63.4462 117.034 79.6187 145.113 99.5686 145.113Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.436 267.697C130.608 267.697 107.943 232.062 101.569 210.681",
    stroke: "black",
    strokeWidth: 9.09742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.859 189.3C117.859 189.3 102.277 217.808 59.7798 217.808",
    stroke: "black",
    strokeWidth: 9.09742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuffuIcon);
export default __webpack_public_path__ + "static/media/puffuIcon.8fa63eef3828274a5fde731e905bc745.svg";
export { ForwardRef as ReactComponent };